import "./App.css";
import "./components/styles/app_resp.css";
// bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";

// slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AppRoutes from "./components/routes/routes";
import Navbar_1 from "./components/layouts/navbar_1";
import Navbar_2 from "./components/layouts/navbar_2";
import Footer from "./components/layouts/footer";
import { useContext, useState } from "react";
import RespNav from "./components/layouts/resp_nav";
import { AppContext } from "./components/contexts/AppContext";

function App() {
  const [isOpen, setIsOpen] = useState(true);
  const { socialMedia } = useContext(AppContext);

  return (
    <div className='App'>
      <Navbar_1 />
      <RespNav />
      <Navbar_2 />
      <AppRoutes />
      <Footer socialMedia={socialMedia} />
      {/* ================================== fixed Social Media ================================== */}
      <div className='fixed_icon' onClick={() => setIsOpen(!isOpen)}>
        <img
          src={`${isOpen ? "/assets/images/white/fixed_closed.svg" : "/assets/images/white/fixed_icon.svg"}`}
          alt='social'
        />
      </div>

      <div className={`fixed_social ${isOpen ? "show" : ""}`}>
        <div className='fixed_item'>
          <a
            href={socialMedia.social.find(item => item.type === "messanger")?.link}
            target='_blank'
            rel='noopener noreferrer'>
            <img src='/assets/images/white/fixed_messanger.svg' alt='messanger' />
          </a>
        </div>
        <div className='fixed_item'>
          <a
            href={socialMedia.social.find(item => item.type === "whatsapp")?.link}
            target='_blank'
            rel='noopener noreferrer'>
            <img src='/assets/images/white/fixed_whatsapp.svg' alt='whatsapp' />
          </a>
        </div>
        <div className='fixed_item'>
          <a href={`tel:${socialMedia.phones[0]}`}>
            <img src='/assets/images/white/fixed_call.svg' alt='call' />
          </a>
        </div>
        <div className='fixed_item'>
          <a
            href={socialMedia.social.find(item => item.type === "telegram")?.link}
            target='_blank'
            rel='noopener noreferrer'>
            <img src='/assets/images/white/fixed_telegram.svg' alt='telegram' />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
